import styled from 'styled-components';
import { colors, radius } from '../../styles/tokens';

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.onSurfaceVariant};
  display: block;
`;

export const PresetsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  margin: 10px 0 16px;
`;

export const PresetButton = styled.button`
  padding: 6px 12px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.full};
  cursor: pointer;

  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.03em;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const PermissionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  max-height: 420px;
  overflow-y: auto;

  margin-bottom: 8px;
  padding-right: 4px;
`;

export const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  padding-bottom: 6px;
  border-bottom: 1px solid ${colors.outlineVariant};
`;

export const CategoryLabel = styled.span`
  flex: 1;
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const CategoryCount = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
`;

export const PermissionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PermissionDescription = styled.span`
  font-size: 13px;
  color: ${colors.onSurface};
`;
